import * as core from "@zod/core";
export const parse = /* @__PURE__ */ core._parse.bind({ Error: core.$ZodError });
export const safeParse = /* @__PURE__ */ core._safeParse.bind({ Error: core.$ZodError });
export const parseAsync = /* @__PURE__ */ core._parseAsync.bind({ Error: core.$ZodError });
export const safeParseAsync = /* @__PURE__ */ core._safeParseAsync.bind({
    Error: core.$ZodError,
});
